import { render, staticRenderFns } from "./CreateTeamModal.vue?vue&type=template&id=07d21513&"
import script from "./CreateTeamModal.vue?vue&type=script&lang=js&"
export * from "./CreateTeamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d21513')) {
      api.createRecord('07d21513', component.options)
    } else {
      api.reload('07d21513', component.options)
    }
    module.hot.accept("./CreateTeamModal.vue?vue&type=template&id=07d21513&", function () {
      api.rerender('07d21513', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/accessmanagement/CreateTeamModal.vue"
export default component.exports